import React, { useState, useEffect } from "react";
import { SuperAdminSidebar, SuperAdminTab } from "../components/admin/SuperAdminSidebar";
import DomainManagement from "../components/admin/DomainManagement";
import UserManagement from "../components/admin/UserManagement";
import Templates from "../../../../features/scopingAi/pages/Templates";
import PromptTemplateConfig from "../../../../features/scopingAi/components/PromptTemplateConfig";
import RetailerManagement from "../../../../features/scopingAi/components/admin/RetailerManagement";
// Lives in the billValidation feature (it reads that feature's services and
// parse-state utils) but is only reachable from here. Same arrangement as
// Templates and RetailerManagement above.
import { ParseStatusPage } from "../../../../features/billValidation/pages/ParseStatusPage";
import { ReportAttachmentSettings } from "../components/admin/ReportAttachmentSettings";
import { UserManagementService } from "../services/userManagementService";

const SuperAdminPortal: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SuperAdminTab>("domains");
  const [pendingUsersCount, setPendingUsersCount] = useState(0);

  useEffect(() => {
    loadPendingUsersCount();
  }, [activeTab]);

  const loadPendingUsersCount = async () => {
    try {
      const result = await UserManagementService.getPendingUsersCount();
      if (!result.error) {
        setPendingUsersCount(result.count);
      }
    } catch (error) {
      console.error("Failed to load pending users count:", error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="flex h-screen">
        <SuperAdminSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          pendingUsersCount={pendingUsersCount}
        />

        <div className="flex-1 overflow-auto">
          {/* ParseStatusPage carries its own page padding, so the wrapper drops
              its p-6 for that tab rather than double-padding it. */}
          <div className={activeTab === "parse-status" ? undefined : "p-6"}>
            {activeTab === "domains" ? (
              <DomainManagement />
            ) : activeTab === "templates" ? (
              <Templates standalone />
            ) : activeTab === "prompt-config" ? (
              <PromptTemplateConfig standalone />
            ) : activeTab === "parse-status" ? (
              <ParseStatusPage />
            ) : activeTab === "retailers" ? (
              <RetailerManagement />
            ) : activeTab === "report-attachment" ? (
              <ReportAttachmentSettings />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminPortal;
